"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dateFns = require("date-fns");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _cccisdDatepicker = _interopRequireDefault(require("cccisd-datepicker"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _SessionSettings = _interopRequireDefault(require("./SessionSettings"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Session = function Session(_ref) {
  var deployments = _ref.deployments,
    displaySettings = _ref.displaySettings,
    isHideDcwDropdown = _ref.isHideDcwDropdown,
    index = _ref.index,
    role = _ref.role,
    session = _ref.session,
    sessionError = _ref.sessionError,
    sessionErrors = _ref.sessionErrors,
    sessions = _ref.sessions,
    updateSessionErrors = _ref.updateSessionErrors,
    updateSessions = _ref.updateSessions;
  var hideDatePickers = displaySettings.hideDatePickers,
    enableAllowRetakeToggle = displaySettings.enableAllowRetakeToggle,
    enableMustTakeInOrderToggle = displaySettings.enableMustTakeInOrderToggle,
    disableSurveyOverride = displaySettings.disableSurveyOverride;
  var isDcwOnlyField = !isHideDcwDropdown && hideDatePickers && !enableAllowRetakeToggle && !enableMustTakeInOrderToggle && disableSurveyOverride;
  var _useState = (0, _react.useState)('isExpanded' in session ? session.isExpanded : true),
    _useState2 = _slicedToArray(_useState, 2),
    isSessionExpanded = _useState2[0],
    setIsSessionExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    firstLoad = _useState4[0],
    setFirstLoad = _useState4[1];
  var _useState5 = (0, _react.useState)(session.deploymentId || undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    deploymentId = _useState6[0],
    setDeploymentId = _useState6[1];
  var _useState7 = (0, _react.useState)(utcToLocal(session.opensAt)),
    _useState8 = _slicedToArray(_useState7, 2),
    opensAt = _useState8[0],
    setOpensAt = _useState8[1];
  var _useState9 = (0, _react.useState)(utcToLocal(session.closesAt)),
    _useState0 = _slicedToArray(_useState9, 2),
    closesAt = _useState0[0],
    setClosesAt = _useState0[1];
  var tzAbbrev = _momentTimezone["default"].tz(_momentTimezone["default"].tz.guess()).format('z');
  (0, _react.useEffect)(function () {
    if (isDcwOnlyField && !isSessionExpanded) {
      setIsSessionExpanded(true);
    }
  }, [isDcwOnlyField]);
  (0, _react.useEffect)(function () {
    if (sessionError) {
      setIsSessionExpanded(true);
    }
  }, [sessionError]);

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE-RELATED //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    if (!firstLoad) {
      setDeploymentId(session.deploymentId);
      setOpensAt(utcToLocal(session.opensAt));
      setClosesAt(utcToLocal(session.closesAt));
    } else {
      setFirstLoad(false);
    }
  }, [session]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL FUNCTIONS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function changeField(event, customSet) {
    var isDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    updateSessions(sessions.map(function (s, i) {
      if (i === index) {
        s[event.target.name] = isDate ? dateToUtc(event.target.value) : event.target.value;
        customSet(event.target.value || '');
      }
      return s;
    }));
  }
  function changeSettings(newSettings) {
    updateSessions(sessions.map(function (s, i) {
      if (i === index) {
        s.settings = newSettings;
      }
      return s;
    }));
  }
  function dateToUtc(date) {
    if (!date) {
      return '';
    }
    return (0, _momentTimezone["default"])(date.toUTCString()).utc().format('YYYY-MM-DD HH:mm:ss');
  }
  function deleteSession() {
    updateSessionErrors(sessionErrors.filter(function (_, i) {
      return i !== index;
    }));
    updateSessions(sessions.filter(function (_, i) {
      return i !== index;
    }));
  }
  function utcToLocal(dateString) {
    if (!dateString) {
      return '';
    }
    return (0, _momentTimezone["default"])(_momentTimezone["default"].utc(dateString).format()).format('YYYY-MM-DD HH:mm:ss');
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var collapseArrow = /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setIsSessionExpanded(function (prev) {
        return !prev;
      });
    },
    className: [_style["default"].collapseArrow, isSessionExpanded ? _style["default"].expanded : _style["default"].collapsed].join(' ')
  }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null));
  var sessionActionButton = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Delete Session"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-xs btn-danger float-end",
    onClick: deleteSession
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
  function deploymentDropdownData() {
    var deploymentsForRole = deployments.filter(function (d) {
      return d.roleHandle === role && (0, _get2["default"])(d, 'settings.isAssignmentPlanEligible');
    }).sort(function (a, b) {
      return a.label.localeCompare(b.label);
    });
    var resetDeployment = {
      handle: '',
      label: '--- Clear Selection ---',
      isResetDeployment: true
    };
    return deploymentId ? [resetDeployment].concat(_toConsumableArray(deploymentsForRole)) : deploymentsForRole;
  }
  function renderDeploymentDropdown() {
    // need .replace because Safari does not parse "-"
    var opensAtString = (0, _dateFns.format)(opensAt instanceof Date ? opensAt : new Date(opensAt.replace(/-/g, '/')), 'MM/DD/YYYY');
    var closesAtString = (0, _dateFns.format)(closesAt instanceof Date ? closesAt : new Date(closesAt.replace(/-/g, '/')), 'MM/DD/YYYY');
    var collapsedDateString = "".concat(opensAt && "Opens ".concat(opensAtString), "\n            ").concat(opensAt && closesAt ? ' - ' : '', "\n            ").concat(closesAt && "Closes ".concat(closesAtString), "\n        ") || '';
    var collapsedDate = !isSessionExpanded && /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].sessionDates
    }, collapsedDateString);
    if (isHideDcwDropdown) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].noDcwDropdown
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _style["default"].label
      }, "Session ", index + 1), collapsedDate);
    }
    var hasError = (0, _get2["default"])(sessionError, 'deploymentId');
    var selectedDcw = deployments.find(function (d) {
      return d.deploymentId === deploymentId;
    });
    var collapsedDcwInfo = !selectedDcw ? 'None selected' : "".concat(selectedDcw.label).concat(selectedDcw && " (".concat(selectedDcw.assignment.label, ")") || '');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].formField
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label ".concat(isDcwOnlyField ? '' : _style["default"].indentedLabel, " ").concat(isSessionExpanded ? '' : _style["default"].collapsed)
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].required
    }, "Data Collection Wave:"), "\xA0\xA0", !isSessionExpanded && /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].collapsedField
    }, collapsedDcwInfo)), isSessionExpanded && !isHideDcwDropdown && /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
      data: deploymentDropdownData(),
      itemComponent: function itemComponent(_ref2) {
        var item = _ref2.item;
        return item.isResetDeployment ? item.label : "".concat(item.label, " (").concat(item.assignment.label, ")");
      },
      onChange: function onChange(e) {
        return changeField({
          target: {
            name: 'deploymentId',
            value: e.deploymentId
          }
        }, setDeploymentId);
      },
      placeholder: "--- Choose a Data Collection Wave ---",
      value: deploymentId,
      valueComponent: function valueComponent(_ref3) {
        var item = _ref3.item;
        return item && "".concat(item.label).concat(item.assignment && " (".concat(item.assignment.label, ")") || '');
      },
      className: (0, _classnames["default"])(hasError && 'is-invalid'),
      valueField: "deploymentId"
    }), collapsedDate, hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "invalid-feedback"
    }, "Data Collection Wave is required"));
  }
  function renderOpensAt() {
    if (hideDatePickers) {
      return null;
    }
    var hasError = (0, _get2["default"])(sessionError, 'opensAt');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].formField
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label ".concat(_style["default"].labelSpacing)
    }, "Opens At:"), /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
      className: (0, _classnames["default"])('form-control', _style["default"].datePicker, hasError && 'is-invalid'),
      dateFormat: "LLL d, yyyy h:mm a",
      name: "opensAt",
      onBlur: function onBlur(e) {
        if (!e.target.value) {
          changeField({
            target: {
              name: 'opensAt',
              value: null
            }
          }, setOpensAt);
        }
      },
      onChange: function onChange(e) {
        changeField({
          target: {
            name: 'opensAt',
            value: e
          }
        }, setOpensAt, true);
      },
      selected: opensAt,
      showTimeSelect: true,
      timeCaption: "time",
      timeFormat: "HH:mm",
      timeIntervals: 30
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "input-group-text ".concat(_style["default"].dateAddon)
    }, tzAbbrev), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].invalid
    }, hasError));
  }
  function renderClosesAt() {
    if (hideDatePickers) {
      return null;
    }
    var hasError = (0, _get2["default"])(sessionError, 'closesAt');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].formField
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label ".concat(_style["default"].labelSpacing)
    }, "Closes At:"), /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
      className: (0, _classnames["default"])(_style["default"].datePicker, 'form-control', hasError && 'is-invalid'),
      dateFormat: "LLL d, yyyy h:mm a",
      name: "closesAt",
      onBlur: function onBlur(e) {
        if (!e.target.value) {
          changeField({
            target: {
              name: 'closesAt',
              value: null
            }
          }, setClosesAt);
        }
      },
      onChange: function onChange(e) {
        changeField({
          target: {
            name: 'closesAt',
            value: e
          }
        }, setClosesAt, true);
      },
      selected: closesAt,
      showTimeSelect: true,
      timeCaption: "time",
      timeFormat: "HH:mm",
      timeIntervals: 30
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "input-group-text ".concat(_style["default"].dateAddon)
    }, tzAbbrev), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].invalid
    }, hasError));
  }
  var sessionSettings = /*#__PURE__*/_react["default"].createElement(_SessionSettings["default"], {
    deployment: deployments.find(function (d) {
      return d.deploymentId === deploymentId;
    }),
    displaySettings: displaySettings,
    isHideDcwDropdown: isHideDcwDropdown,
    session: session,
    setSettings: changeSettings,
    settings: session.settings || {}
  });
  if (isHideDcwDropdown && hideDatePickers) {
    return sessionSettings;
  }
  if (isDcwOnlyField) {
    return renderDeploymentDropdown();
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].sessionContainer
  }, collapseArrow, isSessionExpanded && sessionActionButton, renderDeploymentDropdown(), isSessionExpanded && renderOpensAt(), isSessionExpanded && renderClosesAt(), isSessionExpanded && sessionSettings);
};
Session.propTypes = {
  deployments: _propTypes["default"].array,
  displaySettings: _propTypes["default"].object,
  isHideDcwDropdown: _propTypes["default"].bool,
  index: _propTypes["default"].number,
  role: _propTypes["default"].string,
  session: _propTypes["default"].object,
  sessionError: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  sessionErrors: _propTypes["default"].array,
  sessions: _propTypes["default"].array,
  updateSessionErrors: _propTypes["default"].func,
  updateSessions: _propTypes["default"].func
};
var _default = exports["default"] = Session;